export class Menu {
  id?: number;
  ruta: string;
  titulo: string;
  clase: string;
  esEnlace: boolean;
  roles: string;
  submenu: boolean;
}
